import React from 'react';
import '../App.css';

import { ScrollButton } from './ScrollButton';
import './HeroSection.css';



const scrollFunction = () =>{
    window.scroll({ 
        top: 800, // could be negative value
        left: 0, 
        behavior: 'smooth' 
      });
};
function HeroSection(){
    return (
        <div className='hero-container'>
        <video src="/videos/video-2.mp4" autoPlay loop muted />
        <h1> MY PORTFOLIO</h1>
        <p> Kamsi Ben Agu</p>
        <div className="hero-btns">
            
            <ScrollButton
            
            className='btn' onClick={scrollFunction} 
            buttonStyle='btn--outline'
            buttonSize='btn--large'
            type=''
            >
            GET STARTED
            
            </ScrollButton>
           
            <ScrollButton 
            className='btn' onClick={scrollFunction}  
            buttonStyle='btn--outline'
            buttonSize='btn--large'
            type=''
            >
            WATCH TRAILER <i className='far fa-play-circle'></i>
            </ScrollButton>
            </div>
        </div>
    )
}
export default HeroSection